module.exports = __webpack_public_path__ + "static/media/gunkan_tobiko.f131a839.jpeg";